import { Link } from "react-router-dom";

export default function Datenschutz() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f0c29, #302b63, #24243e)",
      color: "#e2e8f0",
      fontFamily: "'Figtree', sans-serif",
      padding: "2rem 1rem",
    }}>
      <div style={{
        maxWidth: "800px",
        margin: "0 auto",
        background: "rgba(255,255,255,0.05)",
        backdropFilter: "blur(16px)",
        borderRadius: "1.5rem",
        border: "1px solid rgba(255,255,255,0.1)",
        padding: "3rem",
      }}>
        {/* Header */}
        <Link to="/" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          color: "#a78bfa",
          textDecoration: "none",
          marginBottom: "2rem",
          fontSize: "0.9rem",
          fontWeight: 500,
        }}>
          ← Zurück zur Startseite
        </Link>

        <h1 style={{
          fontSize: "2.5rem",
          fontWeight: 800,
          background: "linear-gradient(135deg, #a78bfa, #60a5fa)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "0.5rem",
        }}>Datenschutzerklärung</h1>
        <p style={{ color: "#94a3b8", marginBottom: "2.5rem", fontSize: "0.9rem" }}>
          Stand: Juli 2026 · Gemäß DSGVO / BDSG
        </p>

        <Section title="1. Verantwortlicher">
          <p>Jan-Lukas Ewerling</p>
          <p>Schillerstraße 45, 66571 Dirmingen</p>
          <p>E-Mail: <a href="mailto:kontakt@kaidra.app" style={{ color: "#a78bfa" }}>kontakt@kaidra.app</a></p>
        </Section>

        <Section title="2. Erhobene Daten & Zwecke">
          <p style={{ lineHeight: 1.8, color: "#94a3b8" }}>
            Beim Besuch dieser Website werden folgende Daten automatisch erhoben:
          </p>
          <ul style={{ color: "#94a3b8", lineHeight: 2, marginLeft: "1.5rem" }}>
            <li>IP-Adresse (anonymisiert)</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Aufgerufene Seiten und Dateien</li>
            <li>Browsertyp und -version</li>
            <li>Betriebssystem</li>
            <li>Referrer-URL</li>
          </ul>
          <p style={{ lineHeight: 1.8, color: "#94a3b8", marginTop: "0.75rem" }}>
            Diese Daten werden ausschließlich zur Sicherstellung des Betriebs und zur
            Verbesserung des Angebots genutzt (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
        </Section>

        <Section title="3. Registrierung & Nutzerkonto">
          <p style={{ lineHeight: 1.8, color: "#94a3b8" }}>
            Bei der Registrierung erheben wir: E-Mail-Adresse, Benutzername und Passwort
            (verschlüsselt gespeichert). Diese Daten sind zur Vertragserfüllung erforderlich
            (Art. 6 Abs. 1 lit. b DSGVO). Du kannst dein Konto jederzeit löschen.
          </p>
        </Section>

        <Section title="4. Google AdSense">
          <p style={{ lineHeight: 1.8, color: "#94a3b8" }}>
            Diese Website nutzt Google AdSense, einen Dienst der Google LLC, 1600 Amphitheatre
            Parkway, Mountain View, CA 94043, USA. Google AdSense verwendet Cookies und
            Web-Beacons, um personalisierte Werbung auszuspielen. Dabei können Daten in die
            USA übertragen werden.
          </p>
          <p style={{ lineHeight: 1.8, color: "#94a3b8", marginTop: "0.75rem" }}>
            Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Du kannst die
            personalisierte Werbung unter{" "}
            <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" style={{ color: "#a78bfa" }}>
              google.com/settings/ads
            </a>{" "}
            deaktivieren. Weitere Infos:{" "}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#a78bfa" }}>
              Google Datenschutzerklärung
            </a>.
          </p>
        </Section>

        <Section title="5. Cookies">
          <p style={{ lineHeight: 1.8, color: "#94a3b8" }}>
            Wir verwenden technisch notwendige Cookies (Session-Cookies für die Authentifizierung)
            sowie optionale Analyse- und Werbe-Cookies (Google AdSense). Technisch notwendige
            Cookies sind Grundlage des Betriebs (Art. 6 Abs. 1 lit. f DSGVO), für optionale
            Cookies fragen wir deine Einwilligung.
          </p>
        </Section>

        <Section title="6. Deine Rechte (Art. 15–22 DSGVO)">
          <ul style={{ color: "#94a3b8", lineHeight: 2, marginLeft: "1.5rem" }}>
            <li>✓ Auskunft über gespeicherte Daten</li>
            <li>✓ Berichtigung unrichtiger Daten</li>
            <li>✓ Löschung deiner Daten</li>
            <li>✓ Einschränkung der Verarbeitung</li>
            <li>✓ Datenübertragbarkeit</li>
            <li>✓ Widerspruch gegen Verarbeitung</li>
          </ul>
          <p style={{ lineHeight: 1.8, color: "#94a3b8", marginTop: "0.75rem" }}>
            Anfragen richte an:{" "}
            <a href="mailto:kontakt@kaidra.app" style={{ color: "#a78bfa" }}>
              kontakt@kaidra.app
            </a>
          </p>
          <p style={{ lineHeight: 1.8, color: "#94a3b8", marginTop: "0.5rem" }}>
            Du hast zudem das Recht zur Beschwerde bei der zuständigen Datenschutzaufsichtsbehörde.
          </p>
        </Section>

        <Section title="7. Datensicherheit">
          <p style={{ lineHeight: 1.8, color: "#94a3b8" }}>
            Die Übertragung erfolgt ausschließlich verschlüsselt via HTTPS (TLS). Passwörter
            werden gehasht gespeichert. Wir setzen technische und organisatorische Maßnahmen
            ein, um deine Daten zu schützen (Art. 32 DSGVO).
          </p>
        </Section>

        <Section title="8. Externe Links & Dienste">
          <p style={{ lineHeight: 1.8, color: "#94a3b8" }}>
            Diese Website lädt Schriftarten von Google Fonts (fonts.googleapis.com). Dabei wird
            deine IP-Adresse an Google übermittelt. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO
            (berechtigtes Interesse an einheitlicher Darstellung).
          </p>
        </Section>

        <div style={{ marginTop: "3rem", paddingTop: "2rem", borderTop: "1px solid rgba(255,255,255,0.1)", display: "flex", gap: "2rem" }}>
          <Link to="/impressum" style={{ color: "#a78bfa", textDecoration: "none", fontSize: "0.9rem" }}>Impressum</Link>
          <Link to="/" style={{ color: "#a78bfa", textDecoration: "none", fontSize: "0.9rem" }}>Startseite</Link>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "2rem" }}>
      <h2 style={{
        fontSize: "1.2rem",
        fontWeight: 700,
        color: "#e2e8f0",
        marginBottom: "0.75rem",
        paddingBottom: "0.5rem",
        borderBottom: "1px solid rgba(167,139,250,0.3)",
      }}>{title}</h2>
      <div style={{ color: "#cbd5e1", lineHeight: 1.8 }}>{children}</div>
    </div>
  );
}
